exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n:root {\n  --header-height: 68px;\n}\n", "", {"version":3,"sources":["/usr/src/app/src/App.vue"],"names":[],"mappings":";AAWA;EACE,sBAAgB;CACjB","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n:root {\n  --header-height: 68px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bd26cd6c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/App.vue
// module id = 7WRL
// module chunks = 72